import React, { Component } from 'react';
import politicas_footer from '../images/politicas_footer.png';
import { translate } from 'react-i18next';

class PoliticasFooter extends Component {
  render() {
    const { t } = this.props;
    return(
      <nav className="header-padding" >
        <div >
            <div className="text-center">
              <img alt="IOS OFFICES" className="header-banner" src={politicas_footer} />
            </div>
        </div>
      </nav>
    );
  }
}

export default translate('common')(PoliticasFooter);



// WEBPACK FOOTER //
// ./src/guest/PoliticasFooter.js